import { UnitSize } from '@pushwoosh/kit-constants';
export const SizeInPxBySpinnerSizeMap = {
  small: UnitSize.ICON_SMALL,
  medium: UnitSize.ICON_MEDIUM
};